import { render, staticRenderFns } from "./ReportA.vue?vue&type=template&id=884121f4&scoped=true&"
import script from "./ReportA.vue?vue&type=script&lang=js&"
export * from "./ReportA.vue?vue&type=script&lang=js&"
import style0 from "./ReportA.vue?vue&type=style&index=0&id=884121f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884121f4",
  null
  
)

export default component.exports